import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, TOKEN_KEY } from "@/lib/api";

const AuthCtx = createContext(null);

export const ROLE_LABELS = { admin: "Admin", compliance: "Compliance", purchasing: "Purchasing / Plant", viewer: "Viewer", account_manager: "Account manager" };

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anonymous

  useEffect(() => {
    if (!localStorage.getItem(TOKEN_KEY)) { setUser(false); return; }
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem(TOKEN_KEY, data.token);
    setUser(data.user);
    return data.user;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem(TOKEN_KEY);
    setUser(false);
  }, []);

  const role = user?.role;
  const can = {
    upload: ["admin", "compliance", "purchasing"].includes(role),
    override: ["admin", "compliance"].includes(role),
    admin: role === "admin",
    packs: ["admin", "compliance", "purchasing", "account_manager"].includes(role),
    accountManager: role === "account_manager",
  };

  return <AuthCtx.Provider value={{ user, login, logout, can }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
